export const plotlyApp = `"""An autogenerated example Plotly Dash app."""

# Import packages
from dash import Dash, html

# Initialize the app
app = Dash(__name__)
server = app.server

# App layout
app.layout = [
    html.H1(children="Hello world!"),
    html.H2(children="I am a Plotly Dash app, deployed with Numerous"),
]

# Run the app
if __name__ == "__main__":
    app.run(debug=True)
` as const;
